import PubSub from "pubsub-js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

import { events } from "./Events";
import Dropdown from "./Dropdown";

export default class ProgramRenderer {
  constructor() {
    this.DOM = {
      sectionEl: document.querySelector("#program"),
      targetEl: document.querySelector('[data-json="program"]')
    }
  }

  init() {
    if (!this.DOM.sectionEl || !this.DOM.targetEl) return;

    this.getChildren();

    this.dataFetchToken = PubSub.subscribe(events.DATA_FETCHED, (msg, data) => {
      if (data.program.length) {
        this.render(data.program);
        PubSub.unsubscribe(this.dataFetchToken);
      };
    });

    this.programRenderToken = PubSub.subscribe(events.PROGRAM_RENDERED, (msg, data) => {
      this.initDropdowns();
      this.initAnim();
      PubSub.unsubscribe(this.programRenderToken);
    });
  }

  getChildren() {
    this.DOM.innerEl = this.DOM.sectionEl.querySelector('.program__inner');
    this.DOM.headingEl = this.DOM.sectionEl.querySelector('.program__heading');
  }

  render(programData) {
    let programString = ``;
    programData.forEach(item => programString += item.html_content);
    this.DOM.targetEl.innerHTML = programString;

    setTimeout(() => PubSub.publish(events.PROGRAM_RENDERED), 10);
  }

  initDropdowns() {
    const dropdownEls = this.DOM.sectionEl.querySelectorAll('[data-dropdown="el"]');

    dropdownEls.forEach(el => {
      el.classList.add('is-open');

      const dd = new Dropdown({
        el: el,
        headEl: el.querySelectorAll('.dropdown__head'),
        bodyEl: el.querySelector('.dropdown__body')
      });

      dd.state.isOpen = true;
      dd.init();
    })
  }

  initAnim() {
    ScrollTrigger.create({
      trigger: this.DOM.sectionEl,
      start: "top+=200 bottom",
      onEnter: () => {
        setTimeout(() => this.DOM.headingEl.classList.add('is-anim-over'), 500);
        this.DOM.sectionEl.classList.add('is-anim-over');

        gsap.to(this.DOM.innerEl, {
          y: 0,
          ease: "back.out(1.75)",
          duration: 0.85,
        })

        gsap.to(this.DOM.innerEl, {
          scale: 1,
          duration: 0.85,
          ease: "expo.out"
        })
      }
    })
  }
}